export default "__VITE_ASSET__$z2918tP__"